import React from 'react';
import PropTypes from 'prop-types';
import CheckboxGroup from 'components/form/InputFields/CheckboxGroup';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { Field } from 'redux-form';

function RenderDaysCheckboxField(props) {
    const {
        label,
        name,
        translate,
        ...otherProps
    } = props;

    const weekdays = [
        {
            label: translate('resources.subscriptionProducts.input.day.1'),
            value: 1,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.2'),
            value: 2,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.3'),
            value: 3,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.4'),
            value: 4,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.5'),
            value: 5,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.6'),
            value: 6,
        },
        {
            label: translate('resources.subscriptionProducts.input.day.7'),
            value: 7,
        },
    ];

    return (
        <Field
            component={ CheckboxGroup }
            fullWidth={ true }
            label={ label }
            name={ name }
            options={ weekdays }
            validate={ validations.required }
            { ...otherProps }
        />
    );
}

RenderDaysCheckboxField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(RenderDaysCheckboxField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderDaysCheckboxField.js